import { clsx } from 'clsx'

import { Accordion } from '@tribeplatform/react-ui-kit/Accordion'
import { IndicatorDot } from '@tribeplatform/react-ui-kit/IndicatorBadge'

import type { Filter } from '../types.js'
import { isValueNotEmpty } from '../utils/values.js'

import { FilterItemPopOver } from './FilterItemPopOver.js'

interface Props {
  filter: Filter
  setFilter: (newFilter: Filter) => void
  removeFilter: () => void
}
export const FilterItem = ({ filter, setFilter, removeFilter }: Props) => {
  const { name, value } = filter
  const hasValidValue = isValueNotEmpty(value)

  return (
    <Accordion iconAlign="trailing" className="-mx-2">
      <Accordion.Button noHover className="hover:text-content-hovered">
        <div className="flex space-x-1 flex-1 truncate justify-between items-center">
          <span
            className={clsx(
              hasValidValue ? 'text-interactive' : 'text-content',
              'font-semibold',
            )}
          >
            {name}
          </span>
          {hasValidValue && (
            <IndicatorDot variant="primary" className="block" />
          )}
        </div>
      </Accordion.Button>
      <Accordion.Panel>
        <FilterItemPopOver
          filter={filter}
          removeFilter={removeFilter}
          onChange={setFilter}
        />
      </Accordion.Panel>
    </Accordion>
  )
}
